var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper success_base jianzhan_base",staticStyle:{"padding-top":"25px"}},[_c('jzcommon',{attrs:{"title":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }